import * as types from './action-types';

// import { errorHandler } from '../../../utils/errors';

import CorporateQuoteWorkflowSetupApi from '../../api/CorporateQuoteWorkflowSetupApi';
import UserApi from '../../api/UserApi';

export const fetchWorkflowSuccess=data=>({
  type:'SET_WORKFLOW_APPROVAL_LIST',
  data:data
});

export const fetchWorkflowList = (params) => {
  return (dispatch) => {
    console.log('fetching workflow list');
    console.log(params);
    
    return CorporateQuoteWorkflowSetupApi.getWorkflowList(params)
      .then(data => dispatch(fetchWorkflowSuccess(data)))
      .catch();
  };
};

export const fetchBusinessEntities=()=>{
  return (dispatch)=>{
    return UserApi.getBusinessEntities()
                    .then(data => {
                      dispatch({
                        type: 'GET_BUSINESS_ENTITIES_SUCESS',
                        businessEntitiesDataSource: data
                      });
                      return data;
                    })
                    .catch((err) => {throw(err);});
    
  };
};

export const setCountry = country => ({
  type: 'SET_COUNTRY',
  data: country
});
export const setDefaultBusinessEntity = businessEntity => ({
  type: 'SET_DEFAULT_BUSINESS_ENTITY',
  data: businessEntity
});
export const setCostcenter = costcenter => ({
  type: 'SET_COSTCENTER',
  data: costcenter
});

export const setBusinessEntity=businessEntity =>({
  type:'SET_BUSINESSENTITY',
  data:businessEntity

});

export const setSelectedApproverDetail=approver=>({
  type:'SET_SELECTED_APPROVER_DETAIL',
  data:approver
});


// WEBPACK FOOTER //
// ./src/features/corporate-quote-workflow-setup/actions.js